export default __webpack_public_path__ + "media/images/messagecards/yellow-82c6c76a7281e6631603dd175b142ce6.jpg";